import CardSaveError from '../../exceptions/cardSaveError';

export const RESET_CHALLENGE = 'RESET_CHALLENGE';

export default () => async dispatch => {
  window.challengeCancelledPollingBreaker = true;
  dispatch({ type: RESET_CHALLENGE, meta: { shouldClearErrorsOfType: CardSaveError.errorType }, payload: {} });
};
